module.exports = __webpack_public_path__ + "static/media/S_F02.c324f8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_F02.png
// module id = 81
// module chunks = 0